module.exports = __webpack_public_path__ + "static/img/img_serve2.1805c3a6.png";